import { cn } from "@/lib/utils";
import { FranklinLogo } from "@/components/ui/franklin-logo";

/**
 * Left gutter of every incoming row: the 24px mark plus the 8px gap that
 * separates it from the bubble. Rows that continue a turn Franklin has already
 * signed (the status line under a streaming draft) pad by this instead of
 * repeating the mark, so their text keeps the bubbles' left edge.
 */
export const CHAT_AVATAR_GUTTER_CLASS = "pl-8";

/**
 * Franklin's mark in the incoming-message gutter — the chat's "who is
 * speaking" icon. `animated` swaps the static mark for the loading animation,
 * which is how the panel says he is working; the image box is the same size in
 * both states so the mark does not jump when the turn finishes.
 *
 * The mark is decorative (`alt=""`): the bubble already reads as Franklin's and
 * the status line carries the working state, so announcing an image before every
 * one of his replies would only add noise to a thread read aloud.
 */
export function ChatAvatar({
  animated = false,
  className,
}: {
  animated?: boolean;
  className?: string;
}) {
  return (
    <FranklinLogo
      size="xs"
      showBorder={false}
      animated={animated}
      alt=""
      className={cn("mt-0.5 flex-shrink-0", className)}
      imageClassName="h-[17px] w-[17px]"
    />
  );
}

/**
 * Placeholder holding the gutter open for a row that stacks under a mark
 * already shown in the same turn — the loading bubble beneath a flushed
 * thought, or a draft that continues one.
 */
export function ChatAvatarSpacer() {
  return <span aria-hidden="true" className="h-6 w-6 flex-shrink-0" />;
}

ChatAvatar.displayName = "ChatAvatar";
